export enum PflegiaFriendsStatisticsAction {
  LinkClick = 'LINK_CLICK',
  RegisterByReferral = 'REGISTER_BY_REFERRAL',
  ReferralEmailSent = 'REFERRAL_EMAIL_SENT',
  WhatsAppReferralMessageSent = 'WHATS_APP_REFERRAL_MESSAGE_SENT',
}
